
<style scoped>
.apexcharts-legend-text {
  font-size: 12px !important;
}
.theme--light.v-sheet {
  /**  background-color: transparent;**/
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: red;
}

.expand-enter,
.expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
</style>
<template>

  <div>

  <div style="position: absolute; top: 10px; left: 10px; z-index: 250">
  <v-tooltip z-index="250" top  v-if="chart.response && chart.response.sqlError">
  <template v-slot:activator="{ on }">
  <v-icon color="red" dark v-on="on">error_outline</v-icon>
  </template>
   <span>{{ chart.response.sqlError }}</span>
  </v-tooltip>
</div>


  <div class="layer" ref="layer" :class="chart.parameters.class.value">

    <!--<drop @drop="handleDrop">-->

      <v-flex xs12>


        <v-card :loading="true"  :elevation="chart.parameters.boxShadow.value" :flat="chart.parameters.boxShadow.value > 0 ? false : true" :class="chart.parameters.class.value" :style="chart.parameters.style.value">


          <div transition="expand" v-show="chart.overlayContent" :style="chart.overlayContentStyle">
            <div v-html="chart.overlayContent"></div>
          </div>
          <!--
          <div class="" v-if="chart.type.includes('apexchart')" style="border: 0px solid blue; height: auto">
          <quill-text  :chart="chart" />
        </div>
        -->
          <!--
          <v-btn small color="primary" @click="alert(); chart.chartData.expand.display = true" dark v-show="chart.chartData.expand.show" :style="chart.chartData.expand.style">Expand Selection</v-btn>
        -->
          <div class="layer-card-content">
            <!-- <h1>{{ chart.id }}</h1> -->


            <!--<component v-bind:is="icomponent" v-bind:appproperties="iproperties" v-bind:grid="grid"></component>-->

            <echart-neon-pie v-if="chart.type == 'echarts.neon.pie'" type="radialBar" :height="height" :chart="chart" :key="chart.id" />
            <taybull-echart v-if="chart.type == 'echarts.map'" :height="height" :chart="chart" :key="chart.id" />
            <taybull-echart v-if="chart.type == 'echarts.motion' && chart.chartData.series.length" :height="height" :chart="chart" :key="chart.id" />

  <!--
            <echart-neon-pie v-if="chart.type == 'echarts.calendar.multiple'" :chart="chart" />
            <echart-neon-pie v-if="chart.type == 'echarts.motion'" :chart="chart" />
          -->
            <apexchart v-if="chart.type == 'bar.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="bar" :height="height" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />

            <table-chart v-if="chart.type == 'table' && chart.chartData.series.length" :chart="chart" :key="chart.id" />

            <number v-if="chart.type == 'sparkline.number' && chart.chartData.series && chart.chartData.series.length" :chart="chart" :key="chart.id" />

            <apexchart v-if="chart.type == 'line.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="line" :height="height" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />
            <apexchart v-if="chart.type == 'area.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="area" :height="height" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />

            <apexchart v-if="chart.type == 'mixed.apexchart'" type="line" :height="height" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />
            <apexchart v-if="chart.type == 'heatmap.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="heatmap" :height="height" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />
            <apexchart v-if="chart.type == 'scatter.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="scatter" :height="height" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />
            <apexchart v-if="chart.type == 'pie.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="pie" :height="height - chart.chartData.decrement" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />
            <apexchart v-if="chart.type == 'donut.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="donut" :height="height - chart.chartData.decrement" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id" />
            <apexchart v-if="chart.type == 'radial.apexchart' && chart.chartData.options && chart.chartData.series && chart.chartData.series.length" type="radialBar" :height="height - chart.chartData.decrement" :options="chart.chartData.options" :series="chart.chartData.series" :key="chart.id"/>
            <summary-chart v-if="chart.type == 'sparkline.summary' && chart.chartData.series && chart.chartData.series.length" :chart="chart" :key="chart.id" />
            <date-filter v-if="chart.type == 'filter.date'" :chart="chart" :key="chart.id" />
            <date-filter v-if="chart.type == 'filter.dropdown'" :chart="chart" :key="chart.id" />
            <selectable-table-chart v-if="chart.type == 'selectable-table'" :chart="chart" :mode="mode" :key="chart.id"/>
            <!--<quill-text v-if="chart.type == 'text.quill' && mode != 'view'" :chart="chart" />-->
            <html-chart v-if="chart.type == 'text.html'" :chart="chart" :key="chart.id + chart.chartData.lastUpdated" />
            <awbform v-if="chart.type == 'form.awb'" :chart="chart" :key="chart.id" />
            <filter-toolbar v-if="chart.type == 'filter.toolbar'" :chart="chart" :key="chart.id" />
            <!--<div v-if="chart.type == 'text.quill' && mode == 'view'" v-html="chart.parameters.content.value" style="text-align: left"></div>-->
            <blank v-if="chart.type == 'blank'" v-bind:chart="chart" :key="chart.id" />
            <formchart v-if="chart.type == 'form.default'" :chart="chart" :key="chart.id" />
            <image-viewer v-if="chart.type == 'image.viewer'" :chart="chart" :key="chart.id" />
            <form-search v-if="chart.type == 'form.search'" :chart="chart" :key="chart.id" />
            <layout-tabs v-if="chart.type == 'layout.tabs'" :chart="chart" :key="chart.id" />
            <card-default v-if="chart.type == 'card.default' && chart.chartData.series && chart.chartData.series.length" :chart="chart" :key="chart.id" />
            <form-builder v-if="chart.type == 'form.builder' && mode != 'view'" :chart="chart" :key="chart.id" />
            <form-display v-if="chart.type == 'form.builder' && mode == 'view'" :chart="chart" :layoutInput="chart.layout" :key="chart.id" :status="chart.status" />
            <gmap v-if="chart.type == 'map.google'" :chart="chart" :key="chart.id" />
            <dms v-if="chart.type == 'dms'" :chart="chart" :key="chart.id" />
            <legalworkflow365chart v-if="chart.type == 'legalworkflow365.template'" :chart="chart" :key="chart.id" />
            <well-filter v-if="chart.type == 'wellfilter'" :chart="chart" :key="chart.id" />
          </div>
        </v-card>


      </v-flex>
    <!--</drop>-->
  </div>
</div>

</template>
<style scoped>
.layer div {
  height: 100%;
  
}


.layer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

}
</style>
<script>



// import DefaultChart from './assets/charts/DefaultChart';
const DefaultChart = () => import('@/components/assets/charts/DefaultChart');
// import Blank from './assets/Blank';
const Blank = () => import('./assets/Blank');
// import VueApexCharts from 'vue-apexcharts';
const VueApexCharts = () => import('vue-apexcharts');
//import TaybullLayout from '@/views/Layout.vue';

// import { Drop } from 'vue-drag-drop';
// import EchartNeonChart from './charts/pie/echart-neon-pie/chart.vue';
const EchartNeonChart = () => import('./charts/pie/echart-neon-pie/chart.vue');
// import NumberChart from '@/components/charts/sparkline/number/chart.vue';
const NumberChart = () => import('@/components/charts/sparkline/number/chart.vue');
// import TaybullEchart from '@/components/charts/echart/chart.vue';
const TaybullEchart = () => import('@/components/charts/echart/chart.vue');
// import SummaryChart from '@/components/charts/sparkline/summary/chart.vue';
const SummaryChart = () => import('@/components/charts/sparkline/summary/chart.vue');
// import DateFilterChart from '@/components/charts/filter/date/chart.vue';
const DateFilterChart = () => import('@/components/charts/filter/date/chart.vue');
// import DropdownFilterChart from '@/components/charts/filter/dropdown/chart.vue';
const DropdownFilterChart = () => import('@/components/charts/filter/dropdown/chart.vue');
// import TextChart from '@/components/charts/text/default/chart.vue';
const TextChart = () => import('@/components/charts/text/default/chart.vue');
//import QuillTextChart from '@/components/charts/text/quill/chart.vue';
// import HtmlChart from '@/components/charts/text/html/chart.vue';
const HtmlChart = () => import('@/components/charts/text/html/chart.vue');
// import TableChart from '@/components/charts/table/default/chart.vue';
const TableChart = () => import('@/components/charts/table/default/chart.vue');
// import SelectableTableChart from '@/components/charts/table/selectable/chart.vue';
const SelectableTableChart = () => import('@/components/charts/table/selectable/chart.vue');
// import FilterToolbarChart from '@/components/charts/filter/toolbar/chart.vue';
const FilterToolbarChart = () => import('@/components/charts/filter/toolbar/chart.vue');
// import AWBFormChart from '@/components/charts/form/awb/chart.vue';
const AWBFormChart = () => import('@/components/charts/form/awb/chart.vue');

const FormChart = () => import('@/components/charts/form/chart.vue');

const ImageViewer = () => import('@/components/charts/image/viewer/chart.vue');

const FormSearch = () => import('@/components/charts/form/search/chart.vue');

const LayoutTabs = () => import('@/components/charts/tabs/layout-tabs/chart.vue');

const FormBuilder = () => import('@/components/charts/form/builder/design.vue');
const FormDisplay = () => import('@/components/charts/form/builder/view.vue');

const Legalworkflow365Chart = () => import('@/components/charts/form/legalworkflow365/template/chart.vue');

const CardDefault = () => import('@/components/charts/card/chart.vue');

const MapGoogle = () => import('@/components/charts/map/gmap/chart.vue');

const DMS = () => import('@/components/charts/dms/chart.vue');

const Wellfilter = () => import('@/components/charts/welldatabase/filter/chart.vue');

import ApiService from '@/services/api.service';

import {
  createNamespacedHelpers
}
from 'vuex';
const chartNamespace = createNamespacedHelpers('charts');



export default {
  name: 'layer',
  props: ['chart', 'mode'],
  data: function() {
    return {
      interval: null,
      sizeInterval: null,
      overlayContent: '',
      lastUpdated: null,
      dialog: false,
      subChartDialog: false,
      height: null
    };
  },
  components: {
    'defaultchart': DefaultChart,
    'blank': Blank,
    'echart-neon-pie': EchartNeonChart,
    // 'drop': Drop,
    'number': NumberChart,
    'summary-chart': SummaryChart,
    'date-filter': DateFilterChart,
    'dropdown-filter': DropdownFilterChart,
    'text-chart': TextChart,
    'taybull-echart': TaybullEchart,
    //'quill-text': QuillTextChart,
    'table-chart': TableChart,
    'html-chart': HtmlChart,
    'selectable-table-chart': SelectableTableChart,
    'filter-toolbar': FilterToolbarChart,
    'apexchart': VueApexCharts,
    'awbform': AWBFormChart,
    'formchart': FormChart,
    'image-viewer': ImageViewer,
    'legalworkflow365chart':Legalworkflow365Chart,
    'form-search': FormSearch,
    'layout-tabs': LayoutTabs,
    'form-builder': FormBuilder,
    'form-display': FormDisplay,
    'card-default': CardDefault,
    'gmap': MapGoogle,
    'dms': DMS,
    'well-filter': Wellfilter,
  },
  computed: {
  },
  methods: {
    ...chartNamespace.mapMutations(['mOpenDashboard']),
    alert() {
      // console.log("clicked");
    },

    handleDrop(data) {
      // this.icomponent = data.appcomponent;
      // alert(`You dropped with data: ${JSON.stringify(data)}`);
    }

  },

  created: function() {
    //  this.icomponent = Object.assign(this.appcomponent);
    //  this.iproperties = Object.assign(this.appproperties);

  },
  mounted() {
    let that = this;

    that.chart.setOverlayContent = function(content) {
      that.overlayContent = content;
    }

    that.chart.openDashboard = function(name) {
        // alert("name");
        that.mOpenDashboard({chart: that.chart, name: name});
      };
    // that.chart.layerReference = that;
    // console.log(this.chart.parameters);

    this.$nextTick(function () {

      // that.chart.setOverlayContent = function(content) {
      //   that.overlayContent = content;
      // }

      // that.chart.layerReference = that;
      that.chart.openDialog = function() {
        // console.log("openDialog");
        // console.log("this.dialog", that.dialog);
        that.dialog = true;
        // console.log("this.dialog", that.dialog);
        // console.log("chart.chartData.expandToPageChart", that.chart.chartData.expandToPageChart)
      };

      // alert("create openDashboard");
      

      if (typeof that.$refs.layer != "undefined") {

        const height = that.$refs.layer.clientHeight - 20;
        that.height = height > 20 ? height : null;
        that.sizeInterval = setInterval(function() {

          if (typeof that.$refs.layer != "undefined") {
            const diff = that.$refs.layer.clientHeight - that.height;
            //if(Math.abs(diff) >= 5) {
            const height = that.$refs.layer.clientHeight - 20;
            that.height = height > 20 ? height : 300;
            //}
          }

          // that.chart.chartData.options.height = that.height;
        }, 1000);



      }

    });

    let parameters = this.chart.parameters;
    let chart = this.chart;

    let lastUpdated = this.lastUpdated;

    if(typeof parameters.refreshInterval != "undefined" && parameters.refreshInterval && parameters.refreshQuery != "undefined" && parameters.refreshQuery) {
      let refrestInterval = parseInt(parameters.refreshInterval.value)*1000;
      let refreshQuery = parameters.refreshQuery.value;

      let params = {};
      let progress = false;
      params.sql = window.btoa(refreshQuery);
      params.pre = 1;
      params.totalItems = 1;
      params.rowsPerPage = 1;

      if(isNaN(refrestInterval)) {
        return;
      }

      if(refrestInterval < 60000) {
        refrestInterval = 60000;
        //console.log(refrestInterval);
        //return;
      }

      // refrestInterval = 1000;

      //console.log("refrestInterval", refrestInterval);
      //return;

      that.interval = setInterval(function() {

        if(progress == true) {
          console.log("update check already in progress");
          return false;
        }
        progress = true;
        ApiService.query('/datasource/sql/' + 979, {
          params: params
        }).then(function(response) {

          progress = false;
          let data = response.data;

          if(data.results.length > 0) {
            let lastChange = Object.values(data.results[0])[0];

            if(lastUpdated == lastChange) {
              console.log("no changes detected");
            } else if(lastUpdated == null) {
              lastUpdated = lastChange;
            } else if(lastUpdated != lastChange) {
              console.log(chart.type + "updating new change pervious:" + lastUpdated + " ;now:" + lastChange);
              lastUpdated = lastChange;
              // chart.setLightUpdate(true);
              chart.hydrate();
            }

          }



        }).catch(function(error) {
          progress = false;
        });
        // console.log("refreshing");
      }, refrestInterval);
    }

    // console.log("chart.parameters", this.chart.parameters);
  },
  beforeDestroy() {
    console.log("destroy");
    try {
      clearInterval(this.interval);
      clearInterval(this.sizeInterval);
      this.interval  = null;
      delete this.chart;
    } catch(err) {
      console.log('err ', err);
    }
    // this.editor.destroy();
  }

}
</script>
